export const activitiesOrder = [
    "name",
];
export const agenciesOrder = [
    "authorizationCode",
    "name",
    "city",
    "activity",
    "siret",
    "createdAtNotFormatted",
];
export const networksOrder = [
    "name",
    "siret",
    "createdAtNotFormatted",
];
export const citiesOrder = [
    "city",
    "zipcode",
    "county",
];
export const documentsOrder = [
    "id", 
    "name", 
    "description",
    "url",
    "createdAtNotFormatted",
    "updatedAtNotFormatted",
];

export const estimateLineOrder = [
    "sectionLine",
    "description",
    "dataInput",
    "usualAvailable",
    "complementaryAvailable",
    "tvaRate",
];

export const emailsOrder = [
    "id", 
    "description", 
    "subject",
];

export const cadOrder = [
    "id",
    "name",
    "description",
    "type",
    "category",
];

export const productsOrder = [
    "id", 
    "name", 
    "defaultPrice",
    "defaultPercent",
    "advisedResell",
];
export const usersOrder = [
    "id", 
    "name",
    "city", 
    "roles",
    "firstName",
    "createdAtNotFormatted",
    "lastLoginNotFormatted",
];

export const agencyUsersOrder = [
    "roles",
    "firstName",
    "lastName",
    "email",
    "createdAtNotFormatted",
    "lastLoginNotFormatted",
];

export const deceasedOrder = [
    "id",
    'agency',
    "lastName",
    "firstName",
    "deathDateNotFormatted",
    'createdAtNotFormatted',
];

export const deceasedOrderDashboard = [
    'lastName',
    "deathDateNotFormatted",
    "ceremonyDateNotFormatted",
    "condolenceMessages",
];